import { render, staticRenderFns } from "./publicCmr.vue?vue&type=template&id=b32a52d6&scoped=true"
import script from "./publicCmr.vue?vue&type=script&lang=js"
export * from "./publicCmr.vue?vue&type=script&lang=js"
import style0 from "./publicCmr.vue?vue&type=style&index=0&id=b32a52d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32a52d6",
  null
  
)

export default component.exports